// extracted by mini-css-extract-plugin
export default {"formErrorNotice":"_70f677c4","demoStripeSuccessMessage":"_dad14ef2","demoCode":"_ba82bd5e"};